import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { PointFeature } from "@evergis/sgis/es/features/PointFeature";
import { Arc } from "@evergis/sgis/es/renders/Arc";
import { EditorPointSymbolParams, ShadowedPointSymbol } from "../editorSymbols/ShadowedPointSymbol";

type SelectedFeature = PointFeature & {
  isSelected: boolean;
};

export type SelectedPointSymbolParams = {
  selectedStrokeColor: string;
  selectedFillColor: string;
} & EditorPointSymbolParams;

export class SelectedPointSymbol extends ShadowedPointSymbol {
  selectedStrokeColor!: string;

  selectedFillColor!: string;

  constructor(options: SelectedPointSymbolParams) {
    super(options);
  }

  protected getShadow(position: [number, number], feature: SelectedFeature, mapCoordinates: Coordinates): Arc | void {
    if (feature.isSelected) {
      return super.getShadow(position, feature, mapCoordinates);
    }
  }

  protected getPoint(position: [number, number], feature: SelectedFeature, mapCoordinates: Coordinates): Arc {
    const pointRender = super.getPoint(position, feature, mapCoordinates);

    if (feature.isSelected) {
      pointRender.strokeColor = this.selectedStrokeColor;
      pointRender.fillColor = this.selectedFillColor;
    }

    return pointRender;
  }
}
